import { render, staticRenderFns } from "./SafePaymentBreakdown.vue?vue&type=template&id=750618af&scoped=true&"
import script from "./SafePaymentBreakdown.vue?vue&type=script&lang=js&"
export * from "./SafePaymentBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./SafePaymentBreakdown.vue?vue&type=style&index=0&id=750618af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750618af",
  null
  
)

export default component.exports